import './index.css'
import { MAX_CHANNELS_LIMITED_MODE } from '@disco/constants/GroupTypes'

import React, { useState } from 'react'
import NotificationSvg from '!@svgr/webpack!assets/icons/notification.svg'
import Button from 'components/ui/button'
import Checkbox from 'components/ui/checkbox'
import ContactUsLink from 'components/ui/contact-us-link'
import DiscoModal from 'components/ui/disco-modal'
type Props = {
  onCloseUpgradeMoreModal: (...args: Array<any>) => any
  onOpenCreateGroupModal: (...args: Array<any>) => any
  showUpgradeMoreModal: boolean
  isTrial: boolean
  id: string
}
export const CustomLibrariesModal = ({
  onCloseUpgradeMoreModal,
  showUpgradeMoreModal,
  isTrial,
  onOpenCreateGroupModal,
  id,
}: Props): React.ReactNode => {
  const [checked, setChecked] = useState(false)
  return (
    <DiscoModal
      onRequestClose={onCloseUpgradeMoreModal}
      style={{
        overlay: {
          zIndex: 1000,
          backgroundColor: '#02120cb3',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      className="CustomLibraries flc"
      isOpen={showUpgradeMoreModal}
      showCloseButton
      modalType="alert"
    >
      <>
        <h2 className="CustomLibrariesModal_Title">
          <NotificationSvg
            className="CustomLibrariesModal_NotificationSvg"
            width={24}
            height={24}
            color="#ffab00"
          />
          <span>{isTrial ? 'Heads up!' : 'Upgrade for more channels'}</span>
        </h2>

        <p className="CustomLibrariesModal_Description">
          {isTrial ? (
            <>
              Our Lite plan is limited to {MAX_CHANNELS_LIMITED_MODE} channels.
              Plus and Pro plans have unlimited channels.
              <br />
              <Button
                appearance="inline-link"
                compact
                link="/pricing"
                caption="View our plans here."
                onClick={onCloseUpgradeMoreModal}
              />
            </>
          ) : (
            <>
              Your Lite plan allows for {MAX_CHANNELS_LIMITED_MODE} channels.
              For more channels, contact us about upgrading below.
            </>
          )}
        </p>

        {isTrial ? (
          <div className="CustomLibrariesModal_ButtonWrapper CustomLibrariesModal_ButtonWrapper--Trial">
            <Checkbox
              checked={checked}
              onChange={(label, newChecked) => {
                setChecked(newChecked)
              }}
              label="Don’t show this message again"
            />
            <Button
              appearance="primary"
              className="CustomLibrariesModal_ButtonUpgrade CustomLibrariesModal_ButtonUpgrade--Trial"
              caption="Got it"
              onClick={() => {
                if (checked) {
                  window.localStorage.setItem(id, new Date().toISOString())
                }

                onOpenCreateGroupModal()
              }}
            />
          </div>
        ) : (
          <div className="CustomLibrariesModal_ButtonWrapper">
            <Button
              className="CustomLibrariesModal_ButtonCancel"
              caption="Cancel"
              onClick={onCloseUpgradeMoreModal}
            />

            <Button
              appearance="primary"
              className="CustomLibrariesModal_ButtonUpgrade"
              caption={
                <ContactUsLink
                  intercomMsg="I’d like to discuss upgrading for more channels."
                  onClick={onCloseUpgradeMoreModal}
                  className="CustomLibrariesModal_ContactUsLink"
                >
                  Upgrade
                </ContactUsLink>
              }
              onClick={onCloseUpgradeMoreModal}
            />
          </div>
        )}
      </>
    </DiscoModal>
  )
}
